module.exports = __webpack_public_path__ + "img/user.42e34083.svg";